module.exports = __webpack_public_path__ + "img/dcmm_24.dd2a09c0.png";